import {CLEAR_CLIPBOARD_DATA, ClipboardActionTypes, SET_CLIPBOARD_DATA} from '../actions/types/clipboard.types';
import {IElement} from '../../incase-domain/elements';

export interface IClipboardState {
    data: IElement | null;
    hasValidData: boolean;
}

export const clipboardPreloadedState: IClipboardState = {
    data: null,
    hasValidData: false,
};

export const clipboardReducer = (state: IClipboardState = clipboardPreloadedState, action: ClipboardActionTypes): IClipboardState => {
    switch (action.type) {
        case SET_CLIPBOARD_DATA:
            return {
                ...state,
                data: action.payload.data,
                hasValidData: true,
            };
        case CLEAR_CLIPBOARD_DATA:
            return {
                ...state,
                data: null,
                hasValidData: false,
            };
        default:
            return state;
    }
};
